import { Avatar, Box, Button, DropdownMenu, DropdownMenuItem, DropdownMenuList, GlobalNavigation, GlobalNavigationColumn, GlobalNavigationItem, MenuSeparator, unit } from '@acast-tech/decibel';
import { AngleDownLightGlyph, CogRegularGlyph, FileAltLightGlyph, SignOutLightGlyph } from '@acast-tech/decibel-glyphs';
import { getImageUrl } from '@acast-tech/product-suite-app-utils';
import React from 'react';
import styled from 'styled-components';
import { generateUrl, hasAccessTo } from '../lib/userAppPermissions';
var AvatarButton = styled(Button).withConfig({
  displayName: "TopNavigationBar__AvatarButton",
  componentId: "sc-1qrwkgh-0"
})(["padding-right:", ";padding-left:", ";"], unit(2), unit(2));

var TopNavigationBar = function TopNavigationBar(_ref) {
  var selected = _ref.selected,
      dashboardUrl = _ref.dashboardUrl,
      createUrl = _ref.createUrl,
      insightsUrl = _ref.insightsUrl,
      financeUrl = _ref.financeUrl,
      userImageUrl = _ref.userImageUrl,
      imageCdnUrl = _ref.imageCdnUrl,
      profileAppUrl = _ref.profileAppUrl,
      privacyPolicyUrl = _ref.privacyPolicyUrl,
      logoutUrl = _ref.logoutUrl,
      customLinks = _ref.customLinks,
      customUserMenuLinks = _ref.customUserMenuLinks,
      anonymous = _ref.anonymous,
      permissions = _ref.permissions,
      roles = _ref.roles,
      token = _ref.token,
      encodedSession = _ref.encodedSession,
      isAuth0 = _ref.isAuth0;

  var renderItem = function renderItem(type, label, href) {
    if (!href) return undefined;
    if (!hasAccessTo(label, permissions, roles)) return undefined;
    var urlWithAccess = generateUrl(label, href, isAuth0, token, encodedSession);
    return React.createElement(GlobalNavigationItem, {
      key: type,
      selected: selected === type,
      href: urlWithAccess,
      "data-test-id": "TopNavigationBar__navItem TopNavigationBar__navItem--".concat(type)
    }, label);
  };

  return React.createElement(GlobalNavigation, null, React.createElement(GlobalNavigationColumn, {
    align: "left"
  }, renderItem('dashboard', 'Dashboard', dashboardUrl), renderItem('create', 'Create', createUrl), renderItem('insights', 'Insights', insightsUrl), renderItem('payout-information', 'Payout Information', financeUrl), customLinks.map(function (_ref2) {
    var label = _ref2.label,
        url = _ref2.url,
        type = _ref2.type;
    return renderItem(type, label, url);
  })), React.createElement(GlobalNavigationColumn, {
    align: "right",
    stretch: true
  }, !anonymous && React.createElement(DropdownMenu, {
    toggle: React.createElement(AvatarButton, {
      variant: "tertiary",
      glyphEnd: AngleDownLightGlyph,
      "aria-label": "user menu"
    }, React.createElement(Box, {
      alignItems: "center"
    }, React.createElement(Avatar, {
      title: "User menu",
      size: "xsmall",
      src: getImageUrl(userImageUrl, imageCdnUrl, {
        w: 48
      })
    })))
  }, React.createElement(DropdownMenuList, null, React.createElement(DropdownMenuItem, {
    glyph: CogRegularGlyph,
    href: profileAppUrl
  }, "Profile settings"), React.createElement(DropdownMenuItem, {
    glyph: FileAltLightGlyph,
    href: privacyPolicyUrl
  }, "Privacy policy"), customUserMenuLinks && customUserMenuLinks.map(function (_ref3) {
    var label = _ref3.label,
        url = _ref3.url,
        onClick = _ref3.onClick,
        glyph = _ref3.glyph;
    return React.createElement(DropdownMenuItem, {
      key: label,
      href: url,
      onClick: onClick,
      glyph: glyph
    }, label);
  }), logoutUrl && React.createElement(React.Fragment, null, React.createElement(MenuSeparator, {
    as: "li"
  }), React.createElement(DropdownMenuItem, {
    glyph: SignOutLightGlyph,
    "data-test-id": "TopNavigationBar__logoutItem",
    href: typeof logoutUrl === 'string' ? logoutUrl : undefined,
    onClick: typeof logoutUrl === 'function' ? logoutUrl : undefined
  }, "Log out"))))));
};

TopNavigationBar.defaultProps = {
  createUrl: undefined,
  insightsUrl: undefined,
  financeUrl: undefined,
  userImageUrl: undefined,
  imageCdnUrl: undefined,
  logoutUrl: undefined,
  customLinks: [],
  customUserMenuLinks: undefined,
  anonymous: false,
  isAuth0: false
};
export default TopNavigationBar;